import { EMPTY_LIST } from '../../../../../constants/common'
import { LISTING_PORTAL_SYNC_STATUS } from '../../../../RentalPortalListing'

import {
  LISTING_PUBLICATION_IN_PROGRESS_SYNC_STATUSES,
  LISTING_PUBLICATION_NOT_PUBLISHED_ROW,
  LISTING_PUBLICATIONS_STATE,
} from './RentalPortalListingProfilePublishings.constants'

function toListingPortalPublicationRow({ connection, publications }) {
  return (
    publications.find(
      publication => publication.portal === connection.portal
    ) ?? {
      ...LISTING_PUBLICATION_NOT_PUBLISHED_ROW,
      id: connection.portal,
      portal: connection.portal,
    }
  )
}

export function getListingPublicationRows({ portals, publications }) {
  const rows = publications ?? EMPTY_LIST

  const portalNames = portals.map(connection => connection.portal)

  return [
    ...portals.map(connection =>
      toListingPortalPublicationRow({ connection, publications: rows })
    ),
    ...rows.filter(publication => !portalNames.includes(publication.portal)),
  ]
}

export function getListingPublicationsState({
  isInitiated,
  isLoadingPortals,
  publications,
  rows,
}) {
  if (!isInitiated || isLoadingPortals) {
    return LISTING_PUBLICATIONS_STATE.loading
  }

  if (!Array.isArray(publications)) {
    return LISTING_PUBLICATIONS_STATE.error
  }

  return rows.length > 0
    ? LISTING_PUBLICATIONS_STATE.table
    : LISTING_PUBLICATIONS_STATE.empty
}

export function getIsListingPublicationInProgress(publication) {
  return LISTING_PUBLICATION_IN_PROGRESS_SYNC_STATUSES.includes(
    publication?.sync_status
  )
}

export function getIsListingPublicationSyncFailed(publication) {
  return publication.sync_status === LISTING_PORTAL_SYNC_STATUS.error
}

export function getHasListingPublicationsInProgress(publications) {
  return (publications ?? EMPTY_LIST).some(getIsListingPublicationInProgress)
}

export function getIsListingPublicationsEmpty(state) {
  return state === LISTING_PUBLICATIONS_STATE.empty
}

export function getIsListingPublicationsError(state) {
  return state === LISTING_PUBLICATIONS_STATE.error
}

export function getIsListingPublicationsLoading(state) {
  return state === LISTING_PUBLICATIONS_STATE.loading
}
